import React, { useState } from "react";
import "./dropdown.css";

interface DropdownProps {
  placeholder: string;
  options: string[];
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  disabledText?: string;
  isLoading?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  placeholder,
  options,
  value,
  onChange,
  disabled = false,
  disabledText,
  isLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option: string) => {
    onChange(option);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    if (!disabled && !isLoading) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div
      className={`dropdown-container ${disabled || isLoading ? "dropdown-disabled" : ""}`}
    >
      <div
        className={`dropdown-button ${value ? "dropdown-selected" : ""} ${
          isOpen ? "dropdown-open" : ""
        }`}
        onClick={toggleDropdown}
      >
        <div className="dropdown-content">
          {value && !isLoading && <span className="dropdown-checkmark">✓</span>}
          <span className="dropdown-text">
            {disabled && disabledText ? disabledText : value || placeholder}
          </span>
        </div>
        {isLoading ? (
          <span className="dropdown-spinner" aria-label="Loading" />
        ) : (
          <span className={`dropdown-arrow ${isOpen ? "dropdown-arrow-up" : "dropdown-arrow-down"}`}>
            ▼
          </span>
        )}
      </div>

      {isOpen && (
        <div
          className={`dropdown-list ${
            value ? "dropdown-list-selected" : "dropdown-list-default"
          }`}
        >
          {options.map((option, index) => (
            <div
              key={index}
              className={`dropdown-option ${
                value ? "dropdown-option-selected" : "dropdown-option-default"
              }`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
